import { createAction, props } from '@ngrx/store';
import { ArcHospiDto,  RefLanguageDto } from 'src/app/api/models';
import { eKioskError } from 'src/app/shared/models/api/constants';

export const identification = createAction(
  '[ArcHospi] Identification',
  props<{ cardNumber: string, insurerId: string, siteId: number, hospitalNo: string, language: RefLanguageDto }>()
);

export const identificationSuccess = createAction(
  '[ArcHospi] Identification success',
  props<{ data: ArcHospiDto }>()
);

export const identificationFailure = createAction(
  '[ArcHospi] Identification failure',
  props<{ error: any }>()
);

export const stopWithError = createAction(
  '[ArcHospi] Stop with error',
  props<{ kioskError: eKioskError }>()
);

export const stopWithErrorSuccess = createAction(
  '[ArcHospi] Stop with error success',
  props<{ data: ArcHospiDto }>()
);

export const stopWithErrorFailure = createAction(
  '[ArcHospi] Stop with error failure',
  props<{ error: any }>()
);

export const agreementSigned = createAction(
  '[ArcHospi] Agreement signed'
);

export const agreementSignedSuccess = createAction(
  '[ArcHospi] Agreement signed success',
  props<{ data: ArcHospiDto }>()
);

export const agreementSignedFailure = createAction(
  '[ArcHospi] Agreement signed failure',
  props<{ error: any }>()
);

export const hospitalSelected = createAction(
  '[ArcHospi] Hospital selected',
  props<{ siteId: number, hospitalNo: string }>()
);

export const hospitalSelectedSuccess = createAction(
  '[ArcHospi] Hospital selected success',
  props<{ data: ArcHospiDto }>()
);

export const hospitalSelectedFailure = createAction(
  '[ArcHospi] Hospital selected failure',
  props<{ error: any }>()
);

export const admissionDateEnteredSuccess = createAction(
  '[ArcHospi] Admission date entered success',
  props<{ data: ArcHospiDto }>()
);

export const admissionDateEnteredFailure = createAction(
  '[ArcHospi] Admission date entered failure',
  props<{ error: any }>()
);

export const admissionDateIntervalError = createAction(
  '[ArcHospi] Admission date interval error'
);

export const admissionDateIntervalErrorSuccess = createAction(
  '[ArcHospi] Admission date interval error success',
  props<{ data: ArcHospiDto }>()
);

export const admissionDateIntervalErrorFailure = createAction(
  '[ArcHospi] Admission date interval error failure',
  props<{ error: any }>()
);

export const contractBlocked = createAction(
  '[ArcHospi] Contract blocked'
);

export const contractBlockedSuccess = createAction(
  '[ArcHospi] Contract blocked success',
  props<{ data: ArcHospiDto }>()
);

export const contractBlockedFailure = createAction(
  '[ArcHospi] Contract blocked failure',
  props<{ error: any }>()
);

export const contractInvalid = createAction(
  '[ArcHospi] Contract invalid',
  props<{ kioskError: eKioskError }>()
);

export const contractInvalidSuccess = createAction(
  '[ArcHospi] Contract invalid success',
  props<{ data: ArcHospiDto }>()
);

export const contractInvalidFailure = createAction(
  '[ArcHospi] Contract invalid failure',
  props<{ error: any }>()
);

export const questionnaireSelected = createAction(
  '[ArcHospi] Questionnaire selected',
  props<{ questionnaireId: number }>()
);

export const questionnaireSelectedSuccess = createAction(
  '[ArcHospi] Questionnaire selected success',
  props<{ data: ArcHospiDto }>()
);

export const questionnaireSelectedFailure = createAction(
  '[ArcHospi] Questionnaire selected failure',
  props<{ error: any }>()
);

export const preHospiOverwritten = createAction(
  '[ArcHospi] Prehospi overwritten'
);

export const preHospiOverwrittenSuccess = createAction(
  '[ArcHospi] Prehospi overwritten success',
  props<{ data: ArcHospiDto }>()
);

export const preHospiOverwrittenFailure = createAction(
  '[ArcHospi] Prehospi overwritten failure',
  props<{ error: any }>()
);

export const preHospiComplete = createAction(
  '[ArcHospi] Prehospi complete',
  props<{ hospitalizationId: number, lightColor: string, medicalFormRequired: boolean, medicalFormName: string, reasons: string }>()
);

export const preHospiCompleteSuccess = createAction(
  '[ArcHospi] Prehospi complete success',
  props<{ data: ArcHospiDto }>()
);

export const preHospiCompleteFailure = createAction(
  '[ArcHospi] Prehospi complete failure',
  props<{ error: any }>()
);

export const medicalFormPrinted = createAction(
  '[ArcHospi] Medical form printed'
);

export const medicalFormPrintedSuccess = createAction(
  '[ArcHospi] Medical form printed success',
  props<{ data: ArcHospiDto }>()
);

export const medicalFormPrintedFailure = createAction(
  '[ArcHospi] Medical form printed failure',
  props<{ error: any }>()
);

export const resetArchospi = createAction("[ArcHospi] Reset");